globalThis.preventdefault = function preventdefault(event) {
  event.preventDefault();
};
